/*
 * DAW · « Prévenez-moi » — abonnement au retour en stock d'une montre précise.
 *
 * Un seul message sera envoyé : Klaviyo consomme l'abonnement après l'alerte.
 * La case « prochains drops », si elle est cochée, ajoute en plus le profil
 * à la liste des drops — c'est un consentement distinct.
 *
 * Le catalogue produits de Klaviyo n'étant pas alimenté, l'évènement de retour
 * en stock ne porte ni photo ni lien produit. On les dépose donc nous-mêmes sur
 * le profil (daw_piece_nom / daw_piece_image / daw_piece_url), d'abord par un
 * appel dédié, puis à nouveau dans la charge de l'abonnement : les e-mails y
 * puisent la photo de la pièce suivie.
 */
(function () {
  'use strict';

  var PROFILE_ENDPOINT = 'https://a.klaviyo.com/client/profiles/';
  var BIS_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var LIST_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var REVISION = '2026-07-15';

  function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  function post(url, key, payload) {
    return fetch(url + '?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    });
  }

  function init(root) {
    var key = root.getAttribute('data-key');
    var list = root.getAttribute('data-list');
    var variant = root.getAttribute('data-variant');
    var form = root.querySelector('[data-daw-notify-form]');
    if (!key || !variant || !form) return;

    /* Une fois l'inscription prise, le formulaire cède la place au message de
       confirmation : c'est plus clair qu'un bouton grisé. */
    var zoneEl = root.querySelector('[data-daw-notify-zone]');
    var doneEl = root.querySelector('[data-daw-notify-done]');

    /* Ce que l'e-mail affichera de la pièce suivie. */
    var props = {};
    var pName = root.getAttribute('data-product');
    var pImage = root.getAttribute('data-image');
    var pUrl = root.getAttribute('data-url');
    if (pName) props.daw_piece_nom = pName;
    if (pImage) props.daw_piece_image = pImage;
    if (pUrl) props.daw_piece_url = pUrl;

    var emailEl = root.querySelector('[data-daw-notify-email]');
    var optinEl = root.querySelector('[data-daw-notify-optin]');
    var submitEl = root.querySelector('[data-daw-notify-submit]');
    var msgEl = root.querySelector('[data-daw-notify-msg]');

    function say(text, kind) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.className = 'daw-signup__msg daw-signup__msg--' + kind;
      msgEl.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = (emailEl && emailEl.value ? emailEl.value : '').trim();
      if (!isEmail(email)) {
        say('Merci de saisir une adresse e-mail valide.', 'ko');
        return;
      }

      if (submitEl) submitEl.disabled = true;
      say('Enregistrement…', 'pending');

      var bisPayload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: variant } }
          }
        }
      };

      var profilePayload = {
        data: {
          type: 'profile',
          attributes: { email: email, properties: props }
        }
      };

      /* La photo doit être posée sur le profil AVANT que l'évènement ne déclenche
         l'accusé de réception : d'où l'attente de cet appel. Un échec ici ne doit
         pas empêcher l'abonnement lui-même — l'e-mail partira simplement sans photo.
         L'abonnement au retour en stock, lui, n'accepte pas de propriétés de profil
         (« 'properties' is not a valid field for the resource 'profile' ») : c'est
         pourquoi elles passent exclusivement par cet appel-ci. */
      post(PROFILE_ENDPOINT, key, profilePayload)
        .then(function (response) {
          if (!(response.status === 202 || response.ok)) {
            return response.text().then(function (body) {
              /* eslint-disable no-console */
              console.log('[DAW prévenez-moi] profil non enregistré', response.status, body);
              return null;
            });
          }
          return null;
        })
        .catch(function (error) {
          console.log('[DAW prévenez-moi] profil injoignable', error);
          return null;
        })
        .then(function () {
          return post(BIS_ENDPOINT, key, bisPayload);
        })
        .then(function (response) {
          if (!(response.status === 202 || response.ok)) {
            return response.text().then(function (body) {
              var detail = '';
              try {
                var parsed = JSON.parse(body);
                if (parsed && parsed.errors && parsed.errors.length) {
                  detail = parsed.errors[0].detail || parsed.errors[0].title || '';
                }
              } catch (e) {
                detail = body ? body.slice(0, 200) : '';
              }
              /* eslint-disable no-console */
              console.log('[DAW prévenez-moi] statut', response.status, body);
              throw new Error(
                'erreur ' + response.status + (detail ? ' — ' + detail : '')
              );
            });
          }
          return null;
        })
        .then(function () {
          /* Consentement distinct : inscription à l'annonce des prochains drops. */
          if (!(optinEl && optinEl.checked && list)) return null;
          var listPayload = {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Prévenez-moi — fiche produit',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                    }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          };
          return post(LIST_ENDPOINT, key, listPayload);
        })
        .then(function () {
          form.reset();
          if (zoneEl && doneEl) {
            zoneEl.hidden = true;
            doneEl.hidden = false;
          } else {
            say('C’est noté.', 'ok');
          }
          if (submitEl) submitEl.disabled = true;
        })
        .catch(function (error) {
          console.log('[DAW prévenez-moi] échec', error);
          if (submitEl) submitEl.disabled = false;
          say(
            'Votre demande n’a pas pu être enregistrée (' +
              (error && error.message ? error.message : 'réseau') +
              '). Merci de réessayer.',
            'ko'
          );
        });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-daw-notify]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
